// @flow
/* eslint sort-keys: "error"*/

/**
 * Keep this in alphabetical order to avoid merge conflicts.
 * Name conventions:
 * - Use HA_SERP prefix for all tests
 * - Use FF suffix for feature flags
 * - Include link to Jira ticket to clean up the test after it runs
 * TODO: runtime configuration of these tests
 */
const TESTS = {
    AMENITIES_CAROUSEL_SERP_WEB: 'Amenities_Carousel_SERP_web', // https://jira.expedia.biz/browse/VRBOSHOP-2329
    HA_FLEX_DATES_MODULE_EXPANDING_COVERAGE:
        'ha_flex_dates_module_expanding_coverage', // https://jira.expedia.biz/browse/VRBOSHOP-2648
    HA_GDPR_BANNER: 'ha_gdpr_banner',
    HA_GX_POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    HA_GX_PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    HA_IDA_LOGIN_TO_SAVE_TRIPBOARD: 'HA_IDA_LOGIN_TO_SAVE_TRIPBOARD',
    HA_IDA_SERP_GOOGLEONETAP: 'HA_IDA_SERP_GOOGLEONETAP',
    HA_IDA_SERP_HEADER_LOGIN_TEST: 'HA_IDA_SERP_HEADER_LOGIN_TEST',
    HA_IDA_V3_LOGIN_TEST: 'HA_IDA_V3_LOGIN_TEST',
    HA_MULTIUNIT_PHOTO_CAROUSEL_TEST: 'HA_MULTIUNIT_PHOTO_CAROUSEL_TEST',
    HA_NATIVE_ADOPTION_BANNER_SEARCH_UI: 'HA_NATIVE_ADOPTION_BANNER_SEARCH_UI',
    HA_NATIVE_ADOPTION_BANNER_USE_HAS_APP:
        'HA_NATIVE_ADOPTION_BANNER_USE_HAS_APP',
    HA_NATIVE_ADOPTION_BANNER_V2: 'HA_NATIVE_ADOPTION_BANNER_V2',
    HA_NATIVE_ADOPTION_PLACEMENTS_MASTER_SWITCH:
        'HA_NATIVE_ADOPTION_PLACEMENTS_MASTER_SWITCH',
    HA_PTA_DATES_AND_NUMBEROFNIGHTSSUMMARY:
        'HA_PTA_SEARCHFORM_datesnumberOfNightsSummary',
    HA_PTA_HEADER_LOGIN_COPY: 'HA_PTA_HEADER_LOGIN_COPY',
    HA_PTA_LANDING_CLADSONSERP: 'HA_PTA_LANDING_CLAdsOnSeRP',
    HA_PTA_LANDING_SERP_TO_SLP_PHASE_1: 'HA_PTA_LANDING_SERPtoSLPPhase1',
    HA_PTA_SEARCHBOX_ADD_AGE_OF_CHILDREN: 'HA_PTA_SEARCHBOX_addAgeOfChildren',
    HA_PTA_SEARCHBOX_HINTTEXTCHOOSINGDATES:
        'HA_PTA_SEARCHBOX_hintTextChoosingDates',
    HA_PULSE_REMOVE_AUTO_SAVE: 'ha_pulse_remove_auto_save',
    HA_PULSE_SAVE_BUTTON_UPDATES: 'ha_pulse_save_button_updates', // 41072
    HA_PULSE_SAVE_CONFIRMATION_SERP_HIT: 'ha_pulse_save_confirmation_serp_hit',
    HA_PULSE_SELECTABLE_BOARD_TITLE: 'ha_pulse_selectable_board_title', // https://jira.expedia.biz/browse/FRIENDS-4173: cleanup
    HA_SERP_ABACUS_PAYLOAD_LIVELAB_CSS: 'HA_SERP_ABACUS_PAYLOAD_LIVELAB_CSS', // https://jira.expedia.biz/browse/VRBOSHOP-1848
    HA_SERP_NUMBER_OF_HITS: 'HA_SERP_NUMBER_OF_HITS', // https://jira.expedia.biz/browse/VRBOSHOP-1849
    HA_SERP_RESULTS_QUERY_REJECTION: 'HA_SERP_RESULTS_QUERY_REJECTION', // https://jira.expedia.biz/browse/VRBOSHOP-1847
    HA_TRAVELER_HEADER_TRAY_MOBILE_APP: 'HA_TRAVELER_HEADER_TRAY_MOBILE_APP',
    HA_TYPEAHEAD_LID_SEARCH: 'HA_TYPEAHEAD_LID_SEARCH',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display_v2',
    MESO_VRBO_DISPLAY_ADS: 'MESO_Vrbo_display_ads',
    VRBO_GDPR_OSANO: 'vrbo_gdpr_osano', // https://jira.expedia.biz/browse/VRBOUITK-1394
    VRBO_LANDING_ARIA_ROLES_ON_SEARCHFORM: 'VRBO_LANDING_ARIArolesOnSearchForm',
    VRBO_LANDING_PROPERTY_HERO_IMAGES_SELECTION:
        'Vrbo_landing_propertyheroimageselection', // (39320) https://jira.expedia.biz/browse/VGT-9107
    VRBO_LANDING_SEARCHFORM_DATEPICKER_DAY_OF_WEEK:
        'VRBO_LANDING_searchFormDatepickerDayOfWeek', // https://jira.expedia.biz/browse/SHCMP-2231
    VRBO_LANDING_SEARCHFORM_DATE_FORMAT: 'VRBO_LANDING_searchFormDateFormat', // https://jira.expedia.biz/browse/SHCMP-2194
    VRBO_LANDING_SERP_INDEXATION_POLICY_MVP:
        'VRBO_LANDING_SERPIndexationPolicyMVP',
    VRBO_LANDING_UPDATED_BREADCRUMB_SEO_TEST_2:
        'VRBO_LANDING_UpdatedBreadcrumbSEOTest2', // https://jira.expedia.biz/browse/VGT-9705
    VRBO_MESO_SERP_DESTINATION_RESULT_LISTING:
        'VRBO_MeSo_SeRPDestinationResultListing', // https://jira.expedia.biz/browse/VRBOADS-75
    VRBO_OPAS_SECONDARY_PRICE_EU: 'vrbo_opas_secondary_price_eu',
    VRBO_RECENTLY_VIEWED_SERP_CAROUSEL: 'Recently_Viewed_SERP_Carousel', // https://jira.expedia.biz/browse/VRBOSHOP-2042
    VRBO_RECO_LARGE_SEARCH_DESTINO: 'Vrbo_reco_large_search_destino',
    VRBO_SERP_HITS_REDESIGN: 'SERP_Hit_Redesign', // https://jira.expedia.biz/browse/VRBOSHOP-2478
    VRBO_SERP_MAB_RECENTLY_VIEWED_CAROUSEL:
        'VRBO_SERP_MAB_RECENTLY_VIEWED_CAROUSEL', // https://jira.expedia.biz/browse/VRBOSHOP-2123
    VRBO_SERP_MULTIPLE_MODULES_WEB: 'VRBO_SERP_Multiple_Modules_web',
    VRBO_SERP_PDP_COVID_BANNER: 'vrbo_serp_pdp_covid_banner',
    VRBO_WEB_APPLIED_FILTERS: 'vrbo_web_applied_filters', // https://jira.expedia.biz/browse/VRBODISCO-2595
    VRBO_WEB_FLEX_DATE_A_INSIGHT: 'vrbo_web_flex_date_a_insight',
    VRBO_WEB_GLOBAL_MESSAGING_ALERT: 'vrbo_web_global_messaging_alert',
    VRBO_WEB_GLOBAL_MESSAGING_BANNER: 'vrbo_web_global_messaging_banner',
    VRBO_WEB_SERP_FEWER_INITIAL_RESULTS: 'vrbo_web_serp_fewer_initial_results' // https://jira.expedia.biz/browse/VRBOSHOP-1846
};
/* The below array evaluated with abacus client utils when this module is dispatched to redux to create the abacus state */
const EVALUATE = Object.values(TESTS);
const EVALUATE_AND_LOG = [];

module.exports = {
    EVALUATE,
    EVALUATE_AND_LOG,
    ...TESTS
};
